import { ReactComponent as Logo } from './logo.svg';

export const Home = () => {
    return (<>
        <Logo className="Home-logo" />
    </>);
}